export const URL_ACCOUNT_FORGOT_PASSWORD = 'URL_ACCOUNT_FORGOT_PASSWORD'
export const URL_ACCOUNT_LOGIN = 'URL_ACCOUNT_LOGIN'
export const URL_ACCOUNT_RESET_PASSWORD = 'URL_ACCOUNT_RESET_PASSWORD'
export const URL_ACCOUNT_CHANGE_USER_EMAIL = 'URL_ACCOUNT_CHANGE_USER_EMAIL'
export const URL_ACCOUNT_SUBSCRIBE = 'URL_ACCOUNT_SUBSCRIBE'
export const URL_ACCOUNT_USER_PROFILE = 'URL_ACCOUNT_USER_PROFILE'
export const URL_ACCOUNT_APPLICANT_FIRST_CONNECTION = 'URL_APPLICANT_FIRST_CONNECTION'
export const URL_ACCOUNT_BUSINESS_SELECT = 'URL_BUSINESS_SELECT'
export const URL_ACCOUNTS_SEARCH = 'URL_ACCOUNTS_SEARCH'

export const URL_BUSINESS_ADD = 'URL_BUSINESS_ADD'
export const URL_BUSINESS_LIST = 'URL_BUSINESS_LIST'
export const URL_BUSINESS_DETAIL = 'URL_BUSINESS_DETAIL'
export const URL_BUSINESS_ADD_USER = 'URL_BUSINESS_ADD_USER'
export const URL_BUSINESS_EDIT_USER = 'URL_BUSINESS_EDIT_USER'

export const URL_PROJECT_ADD = 'URL_PROJECT_ADD'
export const URL_PROJECT_LIST = 'URL_PROJECT_LIST'

export const URL_ROOT = 'URL_ROOT'

export const URL_USER_DASHBOARD = 'URL_USER_DASHBOARD'

export const URL_STATIC_PAGES = 'URL_STATIC_PAGES'
export const URL_INDICATOR_GENERAL = 'URL_INDICATOR_GENERAL'
export const URL_INDICATOR_PROJECT = 'URL_INDICATOR_PROJECT'
export const URL_GENERAL_COMPLIANCE = 'URL_GENERAL_COMPLIANCE'
export const URL_PROJECT_COMPLIANCE = 'URL_PROJECT_COMPLIANCE'

export const URL_PENDING_TASKS = 'URL_PENDING_TASKS'

export const URL_MANUAL_GENERATION = 'URL_MANUAL_GENERATION'

export const URL_STYLE_GUIDE = 'URL_STYLE_GUIDE'

export const URL_QUESTIONNAIRE_ESG = 'URL_QUESTIONNAIRE_ESG'
export const URL_QUESTIONNAIRE_ESG_ADMIN = 'URL_QUESTIONNAIRE_ESG_ADMIN'
